export default {"src":"/_next/static/media/chicken_sad.23bb618d.svg","height":391,"width":201};